<!-- 確認画面用単一項目行: ラベルと値を表示する汎用行コンポーネント -->
<template>
  <tr :class="{ 'group-start': groupStart, 'group-end': groupEnd }">
    <th class="single-item" colspan="2">{{ label }}</th>
    <td>{{ value || "—" }}</td>
  </tr>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  value?: string | number | null;
  groupStart?: boolean; // 繰り返しグループの先頭行（区切り線と上余白）
  groupEnd?: boolean; // 繰り返しグループの末尾行（下余白）
}>();
</script>
